export const FETCH_AUDITREPORT_ERROR =
  'Não foi possível reportar o acesso ao audit.';
